module.exports = __webpack_public_path__ + "img/profits.0bce2cc8.svg";